import { SPA_NUMBERS } from "constants/endpoints";
import { get, post, put, deleteApi } from "services/network";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";

export const getSpas = async (params = {}) => {
  // Example: params = { page, perPage, search }
  const page = params.page || 1;
  const perPage = params.perPage || 10;
  const search = params.search || "";
  let url = `${SPA_NUMBERS}?page=${page}&per=${perPage}`;
  if (search) url += `&query=${encodeURIComponent(search)}`;
  return get(url, true);
};

export const getSpaById = async (id) => {
  return get(`${SPA_NUMBERS}/${id}`, true);
};

export const createSpa = async (data) => {
  try {
    const result = await post(SPA_NUMBERS, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="SPA created successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={
          Object.values(error?.response?.data?.errors)[0] ||
          error?.response?.statusText
        }
      />
    );
  }
};

export const updateSpa = async (id, data) => {
  try {
    const result = await put(`${SPA_NUMBERS}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="SPA updated successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
  }
};

export const deleteSpa = async (id) => {
  return deleteApi(`${SPA_NUMBERS}/${id}`);
};
